import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-socialbuttons',
  templateUrl: './socialbuttons.component.html',
  styleUrls: ['./socialbuttons.component.scss']
})
export class SocialbuttonsComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() {
  }

}
